import { ReactNode, useReducer } from 'react';

import {
	ModalDataProvider,
	initialState,
	HIDE_CONFIRM,
	SHOW_CONFIRM,
	ModalAction,
} from './useModal';
import { ConfirmModal } from '../../components/Modal/ConfirmModal';

const ModalProvider = ({ children }: { children?: ReactNode }) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	const handleClose = () => {
		dispatch({ type: HIDE_CONFIRM });
	};

	return (
		<ModalDataProvider value={{ state, dispatch }}>
			{children}
			<ConfirmModal onClose={handleClose} onConfirm={state.submitAction} {...state} />
		</ModalDataProvider>
	);
};

const reducer = (state = initialState, action: ModalAction) => {
	switch (action.type) {
		case SHOW_CONFIRM:
			return {
				...action.payload,
				visible: true,
			};
		case HIDE_CONFIRM:
			return initialState;
		default:
			return initialState;
	}
};

export { ModalProvider };
